// extracted by mini-css-extract-plugin
module.exports = {"dropdownSelector":"dropdown-selector_dropdownSelector__8Ng7S","video-spin":"dropdown-selector_video-spin__3eEsl"};